import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeople2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"people-2, user, person, member"} maskId="square-filled-radius-0-stroke-1-IconPeople2"><path d="M6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5Z" fill="currentColor"/><path d="M3 21V18.5C3 16.0147 5.01472 14 7.5 14H16.5C18.9853 14 21 16.0147 21 18.5V21C20.5375 21 3.46249 21 3 21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPeople2;
